/**
 * @generated SignedSource<<ed760a61c0c4025dac1c4e0b43c3297f>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadWebItemLocationWithSpaceKeyQuery$variables = {
  location?: string | null | undefined;
  locations?: ReadonlyArray<string | null | undefined> | null | undefined;
  spaceKey?: string | null | undefined;
  version?: number | null | undefined;
};
export type preloadWebItemLocationWithSpaceKeyQuery$data = {
  readonly space: {
    readonly homepageId: string | null | undefined;
    readonly homepageWebSections: ReadonlyArray<{
      readonly cacheKey: string | null | undefined;
      readonly id: string | null | undefined;
      readonly items: ReadonlyArray<{
        readonly accessKey: string | null | undefined;
        readonly completeKey: string | null | undefined;
        readonly hasCondition: boolean | null | undefined;
        readonly icon: {
          readonly height: number | null | undefined;
          readonly path: string;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly label: string | null | undefined;
        readonly moduleKey: string | null | undefined;
        readonly params: ReadonlyArray<{
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly section: string | null | undefined;
        readonly styleClass: string | null | undefined;
        readonly tooltip: string | null | undefined;
        readonly url: string | null | undefined;
        readonly urlWithoutContextPath: string | null | undefined;
        readonly weight: number | null | undefined;
      } | null | undefined>;
      readonly label: string | null | undefined;
      readonly styleClass: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type preloadWebItemLocationWithSpaceKeyQuery = {
  response: preloadWebItemLocationWithSpaceKeyQuery$data;
  variables: preloadWebItemLocationWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "location"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locations"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "label"
},
v3 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "homepageId"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "location",
            "variableName": "location"
          },
          {
            "kind": "Variable",
            "name": "locations",
            "variableName": "locations"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          }
        ],
        "concreteType": "WebSection",
        "kind": "LinkedField",
        "name": "homepageWebSections",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "cacheKey"
          },
          (v3/*: any*/),
          {
            "concreteType": "WebItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accessKey"
              },
              {
                "kind": "ScalarField",
                "name": "completeKey"
              },
              {
                "kind": "ScalarField",
                "name": "hasCondition"
              },
              (v1/*: any*/),
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "height"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "width"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "params",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "moduleKey"
              },
              {
                "kind": "ScalarField",
                "name": "section"
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "tooltip"
              },
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "urlWithoutContextPath"
              },
              {
                "kind": "ScalarField",
                "name": "weight"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
    "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
    "metadata": {},
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
  }
};
})();

(node as any).hash = "fb9ef136f5257fc82dc16b8dc37de41b";

export default node;
